export default __webpack_public_path__ + "static/media/Update5.ef340f83.png";